import { getApi } from "../utils/api";
import {
  API_GET_SHADOW_EMPLOYEES_LIST,
  API_GET_SHADOW_RESOURCE_PROJECT_DETAILS_BY_PROJECT_ID,
  API_GET_PROJECT_MEMBERS_BY_PROJECT_ID,
} from "../config/Endpoints";
import Cookies from "js-cookie";

export const fetchShadowEmployeesListService = async (set, projectId) => {
  set({ loading: true });
  try {
    const accessToken = Cookies.get("accessToken");
    const res = await getApi(API_GET_SHADOW_EMPLOYEES_LIST, accessToken);
    const users = res.data?.data || [];
    const projectRes = await getApi(
      `${API_GET_PROJECT_MEMBERS_BY_PROJECT_ID}/${projectId}`,
      accessToken
    );
    const projectMembers = projectRes.data?.data || [];
    const shadowProjectRes = await getApi(
      `${API_GET_SHADOW_RESOURCE_PROJECT_DETAILS_BY_PROJECT_ID}/${projectId}`,
      accessToken
    );
    const shadowProject = shadowProjectRes.data?.data || {};
    const shadowResources = shadowProject.shadowResources || [];
    const projectMemberIds = new Set(projectMembers.map((m) => m.employeeId));
    const shadowResourceIds = new Set(
      shadowResources.map((s) => s.shadowEmployeeId)
    );
    const filteredUsers = users.filter(
      (u) => !projectMemberIds.has(u.id) && !shadowResourceIds.has(u.id)
    );

    const options = filteredUsers.map((u) => ({
      value: u.id,
      label: u.name,
    }));

    set({ shadowEmployeeList: options, loading: false });
  } catch (err) {
    console.error("Error fetching shadow employees:", err);
    set({ loading: false });
  }
};
